import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1505Component } from './kymw1505.component';
import { GetMarkPublishOrderList } from './api-services/get-mark-publish-order-list-service';
import { UpdateMarkPublishOrder } from './api-services/update-mark-publish-order-service';

/**
 * アイコン掲載順設定画面 モジュール設定クラス
 *
 * @export KYMW1505Module
 * @class KYMW1505Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
  ],
  declarations: [
    KYMW1505Component,
  ],
  providers: [
    GetMarkPublishOrderList,
    UpdateMarkPublishOrder
  ],
})
export class KYMW1505Module {
}
